import { render, staticRenderFns } from "./PaymentMethodMultipleSelector.vue?vue&type=template&id=fddcae6a&scoped=true"
import script from "./PaymentMethodMultipleSelector.vue?vue&type=script&lang=js"
export * from "./PaymentMethodMultipleSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddcae6a",
  null
  
)

export default component.exports